import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, CITIES } from "../lib/site";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-obsidian text-cream">
      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12">
        <h2 className="font-heading text-5xl font-extrabold leading-[0.95] tracking-tight sm:text-7xl lg:text-8xl">
          Synergy<span className="text-gold">.</span> Solar Inc.
        </h2>
        <div className="mt-14 grid gap-12 border-t border-white/10 pt-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <Logo dark />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream/60">
              {COMPANY.tagline}. Turnkey rooftop solar with Tier-1 panels and 25-year warranties.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-gold">Cities</p>
            <ul className="mt-4 space-y-2">
              {CITIES.map((c) => (
                <li key={c.slug}>
                  <Link to={`/solar/${c.slug}`} data-testid={`footer-city-${c.slug}`}
                    className="text-sm text-cream/70 transition-colors hover:text-gold">Solar in {c.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-gold">Explore</p>
            <ul className="mt-4 space-y-2 text-sm text-cream/70">
              <li><Link to="/about" className="transition-colors hover:text-gold">About us</Link></li>
              <li><Link to="/services" className="transition-colors hover:text-gold">Services</Link></li>
              <li><Link to="/projects" className="transition-colors hover:text-gold">Projects</Link></li>
              <li><Link to="/contact" className="transition-colors hover:text-gold">Contact & quote</Link></li>
              <li><Link to="/admin" className="transition-colors hover:text-gold">Leads dashboard</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-gold">Contact</p>
            <ul className="mt-4 space-y-3 text-sm text-cream/70">
              <li><a href={COMPANY.phoneHref} className="flex items-center gap-2 transition-colors hover:text-gold"><Phone className="h-4 w-4" /> {COMPANY.phone}</a></li>
              <li><a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 transition-colors hover:text-gold"><Mail className="h-4 w-4" /> {COMPANY.email}</a></li>
              <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0" /> {COMPANY.address}</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-cream/50 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Synergy Solar Inc. All rights reserved.</p>
          <p className="font-mono">POWERED BY SUNSHINE · TRICITY, INDIA</p>
        </div>
      </div>
    </footer>
  );
}
